// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"008b99e0","155":"008b99e0","212":"008b99e0","234":"008b99e0","420":"fa36e9f4","475":"008b99e0","508":"008b99e0","555":"008b99e0","751":"008b99e0","826":"008b99e0","828":"2a913ed2","871":"3326afab","920":"3c1d6b20"}[chunkId] + ".chunk.css";
};